(() => {
	const videos = document.querySelectorAll('video[preload="metadata"][src*="#t="]');

	videos.forEach((video) => {
		video.addEventListener('loadedmetadata', () => {
			video.currentTime = 0;

			video.addEventListener(
				'seeked',
				function preventInitialSeeked(event) {
					event.stopImmediatePropagation();
					video.removeEventListener('seeked', preventInitialSeeked);
				},
				true,
			);
		});
	});
})();
